import { useRoutes } from 'react-router-dom';
// components
import SmartRootRedirect from 'src/components/smart-root-redirect';
//
import { authRoutes } from './auth';
import { dailyOverviewRoutes } from './daily-overview';
import { fulfillmentsRoutes } from './fulfillments';
import { installationRoutes } from './installation';
import { businessOverviewRoutes } from './business-overview';
import { inventoryHealthRoutes } from './inventory-health';
import { mainRoutes } from './main';
import { onboardingRoutes } from './onboarding';
import { productsRoutes } from './products';
import { purchaseOrdersRoutes } from './purchaseOrders';
import { recommendationRoutes } from './recommendation';
import { rulesRoutes } from './rules';
import { settingsRoutes } from './settings';
import { setupRoutes } from './setup';
import { shopifyRoutes } from './shopify';
import { stockChangesRoutes } from './stockChanges';
import { supplierPerformanceRoutes } from './supplier-performance'; // Redirect to new location
import { suppliersRoutes } from './suppliers';
import { utilityRoutes } from './utility';
import { warehousesRoutes } from './warehouses';
import { debugRoutes } from './debug';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <SmartRootRedirect />,
    },

    // Auth routes
    ...authRoutes,

    // Onboarding routes
    ...onboardingRoutes,

    // Page routes
    ...dailyOverviewRoutes,
    ...businessOverviewRoutes,
    ...inventoryHealthRoutes,
    ...purchaseOrdersRoutes,
    ...fulfillmentsRoutes,
    ...productsRoutes,
    ...suppliersRoutes,
    ...supplierPerformanceRoutes, // Redirect to /suppliers/performance
    ...warehousesRoutes,
    ...stockChangesRoutes,
    ...utilityRoutes,
    ...rulesRoutes,
    ...recommendationRoutes,
    // Setup — first-install status page
    ...setupRoutes,
    // Installation routes
    ...installationRoutes,
    // Shopify routes
    ...shopifyRoutes,
    // Settings routes
    ...settingsRoutes,
    // Main routes
    ...mainRoutes,
    ...debugRoutes,

    // No match 404
    { path: '*', element: <SmartRootRedirect /> },
  ]);
}
